module.exports = __webpack_public_path__ + "static/media/pull_ups-01.a6dcc7ca.png";